import React from "react";
import {observer} from "mobx-react";
import {
    IUserProfileEditorViewModel
} from "../../../../../services/user/models/profile/user-profile-editor-view-model.interface";
import {
    PersonNameFieldEditorComponent
} from "../../../../../components/forms/person/person-name-field-editor.component";
import {GenderFieldEditorComponent} from "../../../../../components/forms/gender/gender-field-editor.component";
import {CountryPickerComponent} from "../../../../../components/country-picker/country-picker.component";
import {FormComponent} from "../../../../../components/forms/form.component";
import {useServices} from "../../../../../hooks/use-services.hook";
import {EmailFieldEditorComponent} from "../../../../../components/forms/contact/email-field-editor.component";
import styled from "styled-components";
import {
    DateFieldEditorWithInputMaskComponent,
    DateFieldMask
} from "../../../../../components/forms/date-time/date-field-editor-with-input-mask.component";
import {PhoneNumberInputComponent} from "../../../../../components/forms/contact/phone-number-input.component";


interface AgencyContactInformationEditorComponentProps {
    userProfileEditor: IUserProfileEditorViewModel;
}


const FormRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${props => props.theme.spacing.flexGap20};
    width: 100%;
    ${props => props.theme.screenMediaQuery.smallScreen} {
        grid-template-columns: 1fr; 
    }
`;

const FormRowOneColumn = styled.div`
  width: 100%;
`;

export const AgencyContactInformationEditorComponent: React.FC<AgencyContactInformationEditorComponentProps> = observer((props) => {
    const services = useServices();
    const fields = props.userProfileEditor.fields;
    const time = services.time;
    const maxDateOfBirth =  time.makeShortDate(time.currentDate);

    return (
        <>
            <FormComponent>
                <FormRow>
                    <PersonNameFieldEditorComponent key={fields.firstName.fieldName} field={fields.firstName} />
                    <PersonNameFieldEditorComponent key={fields.lastName.fieldName} field={fields.lastName} />
                </FormRow>
                <FormRow>
                    <DateFieldEditorWithInputMaskComponent key={fields.dateOfBirth.fieldName} field={fields.dateOfBirth} maxDate={maxDateOfBirth} mask={DateFieldMask.DDMMYYYY} />
                    <GenderFieldEditorComponent  key={fields.gender.fieldName} field={fields.gender} useGenderAsNumber={true} />
                </FormRow>
                <FormRow>
                    <CountryPickerComponent key={fields.residentCountry.fieldName} field={fields.residentCountry}/>
                    <CountryPickerComponent key={fields.nationality.fieldName} field={fields.nationality}/>
                </FormRow>
                <FormRowOneColumn>
                    <EmailFieldEditorComponent key={fields.emailAddress.fieldName} field={fields.emailAddress} />
                </FormRowOneColumn>
                <FormRow>
                    <PhoneNumberInputComponent key={fields.phoneNumber.fieldName} field={fields.phoneNumber} />
                    <PhoneNumberInputComponent key={fields.workPhoneNumber.fieldName} field={fields.workPhoneNumber} />
                </FormRow>
            </FormComponent>
        </>
    );
})